// TabBar.tsx — the v4 bottom tab-bar. Six tabs per the implementation guide:
// Home, Activity, Roadmap, Entities, Dispatch, Docs.

import { Icons } from "../components/Icons.js";

export type V4Tab = "home" | "activity" | "roadmap" | "entities" | "dispatch" | "docs";

const TABS: { id: V4Tab; label: string; icon: keyof typeof Icons }[] = [
  { id: "home", label: "Home", icon: "Home" },
  { id: "activity", label: "Activity", icon: "Feed" },
  { id: "roadmap", label: "Roadmap", icon: "Map" },
  { id: "entities", label: "Entities", icon: "Entities" },
  { id: "dispatch", label: "Dispatch", icon: "Dispatch" },
  { id: "docs", label: "Docs", icon: "Docs" },
];

export function TabBar({
  active,
  onChange,
}: {
  active: V4Tab;
  onChange: (tab: V4Tab) => void;
}) {
  return (
    <nav className="tab-bar">
      {TABS.map((tab) => {
        const Icon = Icons[tab.icon];
        const isActive = active === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            className={`tab${isActive ? " active" : ""}`}
          >
            <Icon size={22} color={isActive ? "var(--accent)" : "var(--text-dim)"} />
            <span>{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
